<script>
import { scanStore, clientStore } from '../../stores';
import { config } from '../../../scripts/defaultURL';
import { clearForm, formatDate, formatPayloadDate } from '../../../scripts/functions';
import { postData } from '../../../scripts/rest';
import * as LR from '@uploadcare/blocks';

LR.registerBlocks(LR);

let savedScans = false;
let cdnUrl;
let fileName;

$: window.addEventListener('LR_DATA_OUTPUT', (e) => {
    console.log('Upload event:', e.detail);
    cdnUrl = e.detail.data[0].cdnUrl;
    fileName = e.detail.data[0].name;
});

function closeModal() {
    clearForm('#addScanModal input');
    document.getElementById('addScanModal').classList.remove('is-active')
    $scanStore['todo'] = 'getData'
}   

function save() {
    let scanPayload = { 
        client_id: $clientStore.client.id,
        email: $clientStore.client.email,
        reminder_sent: false,
        report: fileName,
        report_url: cdnUrl,
        type: document.querySelector('#type').value,
        date: formatPayloadDate(document.querySelector('#date').value),
        followup: document.querySelector('#followup_date').innerText
    };
    
    console.log('scanPayload',scanPayload);

    postData(`${config.defaultURL}/scans/add`, scanPayload)
    .catch((error) => console.error('Failed to post scan:', error))
    .then((res) => {
        console.table(res)
        savedScans = true;
        closeModal();
    });
}

function followUpDate(months) {
    if (!document.querySelector('#date').value) {
        alert('Please fill in the Date field before clicking a "Follow up in" button');
        return;
    }

    const d = new Date(document.querySelector('#date').value);
    d.setMonth(d.getMonth() + months);
    
    let month = (d.getMonth()+1).toString();
    let day = d.getDate().toString();
    
    if (month.length == 1) month = `0${month}`;
    if (day.length == 1) day = `0${day}`;

    document.querySelector('#followup_date').innerText = `${d.getFullYear()}-${month}-${day}`;
}
</script>
  
<style>
.modal-card-title {
    margin-bottom: 0 !important;
}

lr-file-uploader-regular {
   --cfg-pubkey: '7e4a5b839b81f4b3a099';
   --cfg-source-list: 'local';
   --darkmode: 0;
}
</style>
    
<div class="modal" id="addScanModal">
    <div class="modal-background" />
    <div class="modal-card">
        <header class="modal-card-head">
        <p class="modal-card-title">Add Scan</p>
        <button on:click={closeModal} class="delete" aria-label="close" />
        </header>
        <section class="modal-card-body">
            <div class="field">
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label class="label">Type</label>
                <div class="select">
                    <select name="type" id="type" required>
                        <option value="">- Select Scan Type -</option>
                        <option value="Breast Study">Breast Study</option>
                        <option value="Chest & Breast Study">Chest & Breast Study</option>
                        <option value="Woman's Health Study">Woman's Health Study</option>
                        <option value="Man's Health Study">Man's Health Study</option>
                        <option value="Full Body Study">Full Body Study</option>
                        <option value="Custom Study">Custom Study</option>
                    </select>
                </div>
            </div>
            <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Date</label>
            <input id="date" class="input" type="date" name="date" placeholder="Enter Scan Date" value={formatDate(new Date())} required />
        </div>
        <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Follow up in:</label>
            <div class="control">
                <button on:click={() => { followUpDate(3) }} name="three">3 months</button>
                <button on:click={() => { followUpDate(6) }}>6 months</button>
                <button on:click={() => { followUpDate(12) }}>12 months</button>
            </div>
            <div id="followup_date"></div>
        </div>
        <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Report</label>
            {#if fileName}
            <div id="fileName">{fileName}</div>
            {/if}
            <lr-file-uploader-regular css-src="https://unpkg.com/@uploadcare/blocks@0.20.1/web/file-uploader-regular.min.css"></lr-file-uploader-regular>
        </div>
        <div class="field is-grouped">
            <div class="control">
                <button on:click={save} class="button is-primary">Save</button>
            </div>
            <div class="control">
                <button
                on:click={closeModal}
                class="button is-primary is-light">Cancel</button>
            </div>
        </div>      
        </section>
    </div>
</div>
    